import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import encryption from '../../Utils/encryptionPassword';
import api from '../../http';
import { useDispatch } from 'react-redux';
import { signin, signout, userAuthAction } from '../../Redux/UserAuthSlice/UserAuthSlice';
import Validator, { ValidationTypes as V_Type, } from 'react-form-supervalidator';
import { addPatient, swtichTab } from 'Redux/TabsSlice/TabsSlice';
import axios from 'axios';
import AccountBlocked from './AccountBlocked';
import { getWriteOffCodes } from 'Redux/DataSlice/DataSlice';
import { get2FAMethodAndPath, lowercaseKeys } from 'Utils/Utils';
import LoginForm from '../../NewComponents/FormComponents/LoginForm';
import { Building2 } from 'lucide-react';
import AuthWrapper from 'NewComponents/Wrappers/AuthWrapper';

const LoginPage = () => {
  const dispatch = useDispatch();
  const [loginObj, setLoginObj] = useState({
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [isAccBlocked, setIsAccBlocked] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const [validationModel, setValidationModel] = useState({
    emailError: null,
    passwordError: null,

  })

  const setValidation = () => {
    let validationObj = {
      ...validationModel,
      emailError: Validator(loginObj.email, [V_Type.required], ['Email is required'],),
      passwordError: Validator(loginObj.password, [V_Type.required], ['Password is required'],),
    }
    setValidationModel(validationObj)
    return Validator(validationObj, V_Type.NullCheck);
  }

  useEffect(() => {
    // Prevent going back to the login page
    window.history.pushState(null, null, window.location.href);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  const handlePopState = (event) => {
    window.history.pushState(null, null, window.location.href);
  };

  const forgotPassword = () => {
    navigate('/forgot-password');
  };

  const onHandleChange = (e) => {
    if ((e.target.name === 'email' || e.target.name === 'password') && e.target.value.length > 40) {

      return;
    }

    setLoginObj((prevobj) => ({
      ...prevobj,
      [e.target.name]: e.target.value
    }));
  };

  const navigateToLogin = () => {
    setIsAccBlocked(false)
    setError("")
  }
  const defaultLogin = () => {
    navigate('/');
    window.history.pushState(null, null, window.location.href);
  }

  const handleLogin = async () => {
    let myValidation = setValidation();
    if (myValidation) {
      return
    } else {
      const { email, password } = loginObj;
      let encryptPassword = encryption(password);
      const payload = {
        email,
        password: encryptPassword
      };
      try {
        const searchParams = new URLSearchParams(location.search);
        const patientId = searchParams.get('patientId');
        const visitId = searchParams.get('visitId');
        setLoading(true);
        const respLogin = await axios.post(`${process.env.REACT_APP_TC_AUTH}/api/Account/Login`, payload)
        const res = respLogin.data.dataModel
        if (res.twoFactorRequired) {
          const config = get2FAMethodAndPath(res)
          if (visitId) {
            return navigate(`${config.path}/?visitId=${visitId}`, { state: { ...respLogin.data.dataModel, transferVia: config.methodName, encryptPassword, email } });
          } else if (patientId) {
            return navigate(`${config.path}/?patientId=${patientId}`, { state: { ...respLogin.data.dataModel, transferVia: config.methodName, encryptPassword, email } });
          }
          return navigate(config.path, { state: { ...respLogin.data.dataModel, transferVia: config.methodName, encryptPassword, email } })
        }

        dispatch(signin({
          token: respLogin.data.dataModel.token,
          twoFactorRequired: respLogin.data.dataModel.twoFactorRequired,
          userPassword: encryptPassword,
          twoFactorViaAuthenticator: respLogin.data.dataModel.twoFactorViaAuthenticator,
          twoFactorViaEmail: respLogin.data.dataModel.twoFactorViaEmail,
          twoFactorViaText: respLogin.data.dataModel.twoFactorViaText,
        }));

        const userInfo = await api.get(`${process.env.REACT_APP_TC_AUTH}/api/Account/GetUserInfo`);
        const { userModuleRights } = userInfo.data.dataModel.loginUserInfo;
        const obj = {
          userInfo: {
            ...userInfo.data.dataModel.loginUserInfo,
            userModuleRights: lowercaseKeys(userModuleRights ?? {}),
          },
          practiceDetails: userInfo.data.dataModel.practiceDetails,
        };
        dispatch(userAuthAction(obj));

        const restrictedAccessEmails = ["cneal@southlandneuromuscular.com", "citlalytgarcia86@gmail.com"]
        if (restrictedAccessEmails.includes(loginObj.email.toLowerCase())) {
          const patientObj = {
            active: true,
            id: 0,
            accountNum: 0,
            subTab: "",
            name: "Search",
            unsavedChanges: false,
            insuranceData: { status: false, editMode: false }
          }
          dispatch(addPatient(patientObj))
        }

        // running the api to get the write off codes
        const writeOffCodes = await api.get(`${process.env.REACT_APP_TC_PMS}/api/DropDown/FindWriteOffCodes`)
        dispatch(getWriteOffCodes(writeOffCodes.data.dataModel))

        if (visitId) {
          try {
            await api.get(`${process.env.REACT_APP_TC_PMS}/api/Visit/FindVisit/${visitId}`,)
            const visitobj = {
              visitId,
              patientId: null,
            }
            dispatch(swtichTab({ parentName: "charges", subTabName: "claim", subTabData: visitobj }));
          } catch (error) {
            defaultLogin()
          }

        }
        else if (patientId) {
          try {
            const ptHeaderResp = await api.get(`${process.env.REACT_APP_TC_PMS}/api/Patient/FindPatientHeaderInfoById/${patientId}`,)
            const patientObj = {
              active: true,
              id: ptHeaderResp.data.dataModel.id,
              accountNum: ptHeaderResp.data.dataModel.accountNum,
              subTab: "Overview",
              name: ptHeaderResp.data.dataModel.name,
              unsavedChanges: false,
              insuranceData: { status: false, editMode: false }
            }
            dispatch(addPatient(patientObj))
          } catch (error) {
            defaultLogin()
          }
        }

        // Prevent going back to the login page after successful login
        navigate('/');
        window.history.pushState(null, null, window.location.href);
        window.addEventListener('popstate', handlePopState);
      } catch (error) {
        setLoading(false);
        setError(error.response.data.responseMessage);
        if (error.response.data.responseMessage.includes("Account Blocked Due to Excessive Login Attempts")) {
          setIsAccBlocked(true)
        }
        dispatch(signout())
        // ErrorHandlingMessage(error);
      } finally { setLoading(false); }
    }
  };
  const handleEnter = (e) => {
    if (e.charCode === 13) {
      handleLogin();
    }
  };

  if (isAccBlocked) {
    return <AccountBlocked navigateToLogin={navigateToLogin} email={loginObj.email} />
  }

  return (
    <AuthWrapper heading="Welcome" subheading="Sign in to continue">
      {/* Login form */}
      <div className="max-w-md mx-auto mt-10">
        <LoginForm
          handleLogin={handleLogin}
          handleEnter={handleEnter}
          onHandleChange={onHandleChange}
          loginObj={loginObj}
          validationModel={validationModel}
          loading={loading}
          forgotPassword={forgotPassword}
          error={error}
        />
      </div>
      {/* Trucare section with icon */}
      <div className="pt-6 mt-8 border-t border-gray-100">
        <div className="flex flex-col items-center text-sm">
          <div className="flex items-center mb-2 space-x-2 text-gray-600">
            <Building2 className="w-5 h-5" />
            <span>Trucare Provider Management</span>
          </div>
          <a href="https://credapp.gettrucare.com/" target="_blank" rel="noopener noreferrer" className="font-semibold text-primary hover:text-primary">
            Access your portal →
          </a>
        </div>
      </div>

    </AuthWrapper>
  );
};

export default LoginPage;
